import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Extraction } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';
import { ExtractionDto } from '@emi/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ExtractionsService {
  constructor(private httpService: HttpService) {}

  public getExtractions(): Observable<Extraction[]> {
    return this.httpService.getHttp<Extraction[]>(
      Constants.ServiceConstants.EXTRACTS
    );
  }

  public createExtraction(extractionData: ExtractionDto): Observable<string> {
    return this.httpService.postHttp<string>(
      Constants.ServiceConstants.EXTRACTS,
      {
        ...extractionData,
        currency: extractionData.currency === 'Local' ? null : extractionData.currency,
      }
    );
  }

  public deleteExtraction(extractionId: number){
    return this.httpService.deleteHttp(
      Constants.ServiceConstants.EXTRACTS,
      extractionId
    );
  }

  public downloadExtraction(extractionId: number) {
    return this.httpService.downloadHttp(
      `${Constants.ServiceConstants.EXTRACTS}/${extractionId}/download`
    );
  }
}
